import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {});

(window as any).chatWootConfig = {
  chatWoot_Url: environment.chatWoot_Url,
  chatWoot_Token: environment.chatWoot_Token,
  blocked_companies: environment.redeCidada_ids
};